import { useTranslation } from "react-i18next";
import useAssignmentsPage from "./hooks/useAssignmentsPage";
import PageContainer from "../../components/PageContainer";
import AssignmentsList from "./AssignmentsList";

const AssignmentsPage = () => {
  const { t } = useTranslation();
  const { assignments, assignmentsLoading } = useAssignmentsPage();

  return (
    <PageContainer header={t("page.tasks")} isLoading={assignmentsLoading}>
      <AssignmentsList {...{ assignments }} />
    </PageContainer>
  );
};

export default AssignmentsPage;
